import React from "react"

import {AppCardTitle, AppCrudTable} from "@components"
import {userSettingCategoryData} from "../../../@signals"
import {actionsColumn, colorColumn, nameColumn} from "./columns"
import { isTourDemoActive } from "@signals/app"
import UserSettingsCategoryTabButton from "../Button"

export default function UserSettingsCategoryTable() {
	if (isTourDemoActive.value && !userSettingCategoryData.value?.length) return null
    return <AppCrudTable
		// The tab's create button with the table's own actions, as every list of the app
		options={{ customToolbar: () => <UserSettingsCategoryTabButton/> }}
		title={<AppCardTitle icon="palette" title="Your Category Colors"/>}
		data={userSettingCategoryData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}